<template>
  <div>
    <div
      class="text-lg md:text-xl still-clean-commit lg:text-2xl text-root-2 font-semibold flex justify-center"
    >
      Select Deposit Type
    </div>
    <div class="flex items-center justify-center mb-1">
      <div
        class="my-3 font-bold bg-root-3 md:w-302px mx-2 mt-3 flex px-1 justify-between items-center rounded-full"
      >
        <div
          @click="changeType('fiat')"
          :class="
            true ? 'bg-primary text-white my-1 text-root-4 rounded-full' : ''
          "
          class="text-xs md:text-13px rounded-full transition duration-700 ease-in-out cursor-pointer px-2.5 py-4 md:px-6 text-root-1"
        >
          Fiat Currency
        </div>
        <div
          class="text-xs cursor-not-allowed md:text-13px rounded-full transition duration-700 ease-in-out px-2.5 py-4 md:px-6 text-root-1"
        >
          Asset Transfer
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    changeType (type) {
      if (this.transaction && Object.keys(this.transaction).length > 0) {
        return
      }
      this.type = type
    }
  }
}
</script>

<style></style>
